// extracted by mini-css-extract-plugin
export default {"resultSection":"ResultPresentation_resultSection__aFoy1"};